import categoryService from "app/common/services/categoryService";
import type { ITableSort } from "app/components/React/Table/types";
import DurationService from "app/services/DurationService";

export interface ITableFiltersState {
    sort: ITableSort;
    search?: string;
    funcFlag?: number;
}

/**
 * Builds the Industry Leaders request params. Deliberately excludes `page` so the same
 * object feeds both the table request and the Excel download URL, which is page-less.
 */
export const getRequestParams = (params, { sort, search, funcFlag }: ITableFiltersState) => {
    const { category, webSource, duration, country } = params;
    const categoryObject = categoryService.categoryQueryParamToCategoryObject(category);
    const { from, to, isWindow } = DurationService.getDurationData(duration).forAPI;
    const trimmedSearch = search?.trim();
    return {
        keys: categoryObject.forApi,
        duration,
        from,
        to,
        webSource,
        isWindow,
        includeSubDomains: true,
        country,
        categoryHash: categoryObject.categoryHash,
        category: categoryObject.forDisplayApi,
        sort: sort.field,
        asc: sort.sortDirection === "asc",
        ...(trimmedSearch ? { filter: `domain;contains;"${trimmedSearch}"` } : {}),
        ...(funcFlag ? { funcFlag } : {}),
    };
};
